import { useMutation, useQueryClient } from '@tanstack/react-query';
import patchNotifications from 'Api/notification/patchNotifications';
import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';

const usePatchNotificationMarkAllAsRead = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return await patchNotifications({});
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notification'] }),
    onSettled: () => onResetLoader(),
    onError: () => onOpenToast({ status: 'error', description: 'Notifikasi gagal diperbarui', duration: 5, alwaysShow: false }),
  });
};

export default usePatchNotificationMarkAllAsRead;
